import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  FaCog,
  FaFileInvoiceDollar,
  FaHome,
  FaIdCard,
  FaLock,
  FaSignOutAlt,
} from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";

import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import logo from "../../../assets/images/logo colegio (32).png";
import "./PortalSidebar.css";

const FAMILY_LINKS = [
  ["/inicio", "Estado de cuenta", FaHome],
  ["/facturas", "Cuotas y facturas", FaFileInvoiceDollar],
  ["/configuracion", "Configuración", FaCog],
];

const EMPLOYEE_LINKS = [
  ["/dashboardEmpleados", "Inicio", FaHome],
  ["/misRecibos", "Recibos de sueldo", FaFileInvoiceDollar],
  ["/perfilEmpleado", "Mi perfil", FaIdCard],
  ["/cambiar-password", "Seguridad", FaLock],
];

export default function PortalSidebar({ employee = false }) {
  const navigate = useNavigate();
  const familyState = useSelector((state) => state.usuario);
  const { empleado, logoutEmpleado } = useContext(AuthEmpleadoContext);
  const family = familyState?.usuario || familyState;
  const links = employee ? EMPLOYEE_LINKS : FAMILY_LINKS;
  const displayName = employee
    ? [empleado?.nombre, empleado?.apellido].filter(Boolean).join(" ")
    : family?.familia?.apellido || family?.apellido || "Familia";
  const email = employee ? empleado?.mail : family?.mail;

  const logout = () => {
    if (employee) {
      logoutEmpleado();
      navigate("/loginEmpleados");
      return;
    }
    localStorage.removeItem("sessionKey");
    localStorage.removeItem("mail");
    navigate("/login");
  };

  return (
    <aside className="tc-portal-sidebar">
      <div className="tc-portal-identity">
        <img src={logo} alt="Colegio Santo Tomás" />
        <span>{employee ? "Portal del docente" : "Portal de familias"}</span>
        <strong>{displayName || (employee ? "Docente" : "Familia")}</strong>
        {email && <small>{email}</small>}
      </div>

      <nav aria-label="Navegación del portal">
        {links.map(([to, label, Icon]) => (
          <NavLink key={to} to={to} className={({ isActive }) => isActive ? "is-active" : ""}>
            <Icon /> {label}
          </NavLink>
        ))}
      </nav>

      <button type="button" className="tc-portal-logout" onClick={logout}>
        <FaSignOutAlt /> Cerrar sesión
      </button>
    </aside>
  );
}
